import React from 'react';
import { ShieldCheck } from 'lucide-react';
import ComingSoonPage from '@/components/ComingSoonPage';

/**
 * Verify Products — Coming Soon.
 *
 * All four role homes have a "Verify Products" tile that navigates
 * to `/verify`. Before PR 9 that route didn't exist and the catch-all
 * sent users to SplashScreen; this page replaces that with an honest
 * placeholder until a real NAFDAC / manufacturer-code verification
 * flow lands.
 */
export default function VerifyPage() {
  return (
    <ComingSoonPage
      titleKey="farmerHome.verifyProducts"
      bodyKey="verify.comingSoonBody"
      icon={ShieldCheck}
      dataTestId="verify-coming-soon"
    />
  );
}
